/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Og_DescriptionInputs */

const en_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three decades of award-winning golf instruction in Des Moines, Iowa.`)
};

const es_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres décadas de instrucción de golf premiada en Des Moines, Iowa.`)
};

const de_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Jahrzehnte preisgekrönter Golfunterricht in Des Moines, Iowa.`)
};

const zh_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在爱荷华州得梅因进行三十年屡获殊荣的高尔夫教学。`)
};

const ar_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثلاثة عقود من تعليم الغولف الحائز على جوائز في Des Moines, Iowa.`)
};

const fr_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois décennies d'enseignement du golf primé à Des Moines, Iowa.`)
};

const vi_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ba thập kỷ giảng dạy golf đạt giải thưởng tại Des Moines, Iowa.`)
};

const sw_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miongo mitatu ya maagizo ya gofu ya mshindi wa tuzo huko Des Moines, Iowa.`)
};

const th_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสอนกอล์ฟที่ได้รับรางวัลมากว่าสามทศวรรษในเมืองดิมอยน์ รัฐไอโอวา`)
};

const bs_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tri decenije nagrađivane golf instrukcije u Des Moinesu, Iowa.`)
};

const ja_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines、Iowaでの受賞歴のあるゴルフ指導、30年。`)
};

const ko_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa에서 수상 경력에 빛나는 골프 지도 30년.`)
};

const pt_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três décadas de instrução premiada de golfe em Des Moines, Iowa.`)
};

const it_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre decenni di istruzione di golf pluripremiata in Des Moines, Iowa.`)
};

const sv_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre decennier av prisbelönt golfinstruktion i Des Moines, Iowa.`)
};

const nl_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie decennia van bekroonde golflessen in Des Moines, Iowa.`)
};

const da_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre årtier med fremragende golfundervisning i Des Moines, Iowa.`)
};

const nb_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre tiår med prisbelønt golf instruksjon i Des Moines, Iowa.`)
};

const fi_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolme vuosikymmentä palkittua golfopetusta Des Moines, Iowa.`)
};

const pl_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trzy dekady nagradzanej instrukcji golfa w Des Moines, Iowa.`)
};

const ru_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Три десятилетия отмеченных наградами инструкций по гольфу в Des Moines, Iowa.`)
};

const tr_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines'te üç on yıl ödüllü golf eğitimi, Iowa.`)
};

const hi_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa में तीन दशकों के पुरस्कार विजेता गोल्फ निर्देश।`)
};

const id_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga dekade memenangkan instruksi golf di Des Moines, Iowa.`)
};

const ms_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga dekad bimbingan golf yang memenangi anugerah di Des Moines, Iowa.`)
};

const cs_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tři desetiletí vítězné golfové výuky v Des Moines, Iowa.`)
};

const el_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τρεις δεκαετίες βραβευμένης εκπαίδευσης γκολφ σε Des Moines, Iowa.`)
};

const he_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלושה עשורים של הוראות גולף עטור פרסים ב Des Moines, Iowa.`)
};

const af_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie dekades se bekroonde gholfonderrig in Des Moines, Iowa.`)
};

const hu_meta_og_description = /** @type {(inputs: Meta_Og_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Három évtizednyi golfoktatás Des Moines, Iowa-ben.`)
};

/**
* | output |
* | --- |
* | "Three decades of award-winning golf instruction in Des Moines, Iowa." |
*
* @param {Meta_Og_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const meta_og_description = /** @type {((inputs?: Meta_Og_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Og_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_og_description(inputs)
	if (locale === "de") return de_meta_og_description(inputs)
	if (locale === "zh") return zh_meta_og_description(inputs)
	if (locale === "ar") return ar_meta_og_description(inputs)
	if (locale === "fr") return fr_meta_og_description(inputs)
	if (locale === "vi") return vi_meta_og_description(inputs)
	if (locale === "sw") return sw_meta_og_description(inputs)
	if (locale === "th") return th_meta_og_description(inputs)
	if (locale === "bs") return bs_meta_og_description(inputs)
	if (locale === "ja") return ja_meta_og_description(inputs)
	if (locale === "ko") return ko_meta_og_description(inputs)
	if (locale === "pt") return pt_meta_og_description(inputs)
	if (locale === "it") return it_meta_og_description(inputs)
	if (locale === "sv") return sv_meta_og_description(inputs)
	if (locale === "nl") return nl_meta_og_description(inputs)
	if (locale === "da") return da_meta_og_description(inputs)
	if (locale === "nb") return nb_meta_og_description(inputs)
	if (locale === "fi") return fi_meta_og_description(inputs)
	if (locale === "pl") return pl_meta_og_description(inputs)
	if (locale === "ru") return ru_meta_og_description(inputs)
	if (locale === "tr") return tr_meta_og_description(inputs)
	if (locale === "hi") return hi_meta_og_description(inputs)
	if (locale === "id") return id_meta_og_description(inputs)
	if (locale === "ms") return ms_meta_og_description(inputs)
	if (locale === "cs") return cs_meta_og_description(inputs)
	if (locale === "el") return el_meta_og_description(inputs)
	if (locale === "he") return he_meta_og_description(inputs)
	if (locale === "af") return af_meta_og_description(inputs)
	if (locale === "hu") return hu_meta_og_description(inputs)
	return en_meta_og_description(inputs)
});